import { useSelector } from 'react-redux';

import SubscriptionShipment from './dashboard/SubscriptionShipment';
import TraditionalShipment from './dashboard/TraditionalShipment';
import { isUpcomingHold, isUpcomingCancel } from './helpers';

const ClubMembershipDisplay = (props) => {
  const { clubMembership } = props;

  const settings = useSelector((state) => state.setting);
  return (
    <>
      <strong>{renderClubName(clubMembership.club)}</strong>
      {renderHold(clubMembership)}
      <br />
      {renderDelivery(clubMembership, settings)}
      <br />
      Bill To: {renderCreditCard(clubMembership.customerCreditCard)}
      <br />
      Status: {clubMembership.status}
      {clubMembership.clubType === 'Traditional' && (
        <TraditionalShipment clubMembership={clubMembership} />
      )}
      {clubMembership.clubType === 'Subscription' && (
        <SubscriptionShipment clubMembership={clubMembership} />
      )}
      <br />
    </>
  );
};

const renderHold = (clubMembership) => {
  if (clubMembership.status === 'On Hold') {
    return (
      <>
        <em>(On Hold)</em>
      </>
    );
  }
  if (isUpcomingCancel(clubMembership)) {
    return (
      <>
        <em>(Upcoming Cancellation)</em>
      </>
    );
  }
  if (isUpcomingHold(clubMembership)) {
    return (
      <>
        <em>(Upcoming Hold)</em>
      </>
    );
  }
  return null;
};

const renderClubName = (club) => {
  if (club && club.title) {
    return club.title;
  }
  return null;
};

const renderDelivery = (clubMembership) => {
  if (clubMembership.orderDeliveryMethod === 'Pickup') {
    return <>Pickup at: {clubMembership.pickupAt.address}</>;
  }
  if (clubMembership.shipTo && clubMembership.shipTo.address) {
    return <>Ship To: {clubMembership.shipTo.address}</>;
  }
  return (
    <>
      Ship To: <div className="c7-message--error">Error: Missing Address</div>
    </>
  );
};

const renderCreditCard = (creditCard) => {
  if (creditCard && creditCard.maskedCardNumber) {
    return `Card ending in ${creditCard.maskedCardNumber.substr(
      creditCard.maskedCardNumber.length - 4
    )}`;
  }
  return (
    <>
      <div className="c7-message--error">Error: Missing Payment</div>
    </>
  );
};

export default ClubMembershipDisplay;
